import React, { useEffect, useMemo, useState } from "react";

import { getImageUrl } from "utils/imageGallery/index";

import HeaderImage from "assets/images/nzCaseStudy/header.png";
import HouseImage from "assets/images/nzCaseStudy/houseImage.jpg";

import "../styles.css";
const NZReportPDFPage1 = ({
    projectIntroduction,
    projectPriorities,
    images = [],
    allImages = [],
    nzPage1Content = {},
    nzUpgradesIncluded = [],
}) => {
    const [imagesWithFixedUrl, setImagesWithFixedUrl] = useState([]);
    const [imgIsWide, setImgIsWide] = useState(false);

    const {
        nzRenovator = "",
        nzEAOrg = "",
        nzPerformance = "",
        nzEnergyReduction = "",
        nzYearBuilt = "",
        nzCompletionYear = "",
        nzLocation = "",
        nzBuildingType = "",
        nzBuildingSize = "",
        nzClimate = "",
    } = nzPage1Content;

    const coverImageSrc = imagesWithFixedUrl[0]?.fileUrl || HouseImage;

    const filteredImages = useMemo(
        () =>
            allImages
                .filter((image) => images.includes(`${image.id}-cover`))
                .map(({ name, ...image }) => ({ ...image, name: name ? name : "Noname Image" })),
        [allImages, images]
    );

    useEffect(() => {
        const fetchImages = async () => {
            const updatedImages = await Promise.all(
                filteredImages.map(async (img) => {
                    const fileUrl = await getImageUrl(img.fileUrl);
                    return { ...img, fileUrl };
                })
            );
            setImagesWithFixedUrl(updatedImages);
        };

        fetchImages();
    }, [filteredImages]);

    const maxColumnLength = 14;

    useEffect(() => {
        // Ensures image always takes up the full div and is cropped accordingly
        const coverImage = new Image();
        coverImage.src = coverImageSrc;
        coverImage.onload = function () {
            // Access naturalWidth and naturalHeight for original dimensions
            const naturalWidth = this.naturalWidth;
            const naturalHeight = this.naturalHeight;

            setImgIsWide(naturalWidth > naturalHeight);
        };
    }, [imagesWithFixedUrl]);

    return (
        <div className="bodyNZPDF">
            <img src={HeaderImage} alt="header" />
            <span className="headerTextNZPDF">CASE STUDY</span>
            <div className="pageContainerNZPDF">
                <div style={{ display: "flex", height: "100%" }}>
                    <div style={{ width: "42%" }}>
                        <div
                            className="centeredCroppedImage"
                            style={{
                                width: "100%",
                                height: "305.6px",
                            }}
                        >
                            <img src={coverImageSrc} className={imgIsWide ? "wideImage" : "tallImage"} alt="house" />
                        </div>
                        <div className="projectInfoContainerNZPDF">
                            <div>
                                <p className="bodyFontNZPDF">{projectIntroduction}</p>
                            </div>
                            <div>
                                <h1
                                    className="titleFontNZPDF"
                                    style={{
                                        fontSize: "24px",
                                        marginBottom: "10px",
                                        textAlign: "center",
                                    }}
                                >
                                    Project Priorities
                                </h1>
                                <ul className="ulListNZPDF">
                                    {projectPriorities.map((priority, index) => (
                                        <li
                                            key={index}
                                            style={{
                                                wordWrap: "break-word",
                                            }}
                                            className="bodyFontNZPDF"
                                        >
                                            <span>{priority}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="generalInfoContainerNZPDF">
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">RENOVATOR:</strong>
                                <span className="generalInfoContentNZPDF">{nzRenovator ? nzRenovator : "N/A"}</span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">ENERGY ADVISOR/SERVICE ORGANIZATION:</strong>
                                <span className="generalInfoContent2NZPDF">{nzEAOrg ? nzEAOrg : "N/A"}</span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">PERFORMANCE:</strong>
                                <span className="generalInfoContentNZPDF">{nzPerformance ? nzPerformance : "N/A"}</span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">ENERGY REDUCTION:</strong>
                                <span className="generalInfoContentNZPDF">
                                    {nzEnergyReduction ? nzEnergyReduction : "N/A"}
                                </span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">YEAR BUILT:</strong>
                                <span className="generalInfoContentNZPDF">{nzYearBuilt ? nzYearBuilt : "N/A"}</span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">YEAR RETROFIT COMPLETED:</strong>
                                <span className="generalInfoContentNZPDF">
                                    {nzCompletionYear ? nzCompletionYear : "N/A"}
                                </span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">LOCATION:</strong>
                                <span className="generalInfoContentNZPDF">{nzLocation}</span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">HOUSE TYPE:</strong>
                                <span className="generalInfoContentNZPDF">
                                    {nzBuildingType ? nzBuildingType : "N/A"}
                                </span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">SIZE:</strong>
                                <span className="generalInfoContentNZPDF">{nzBuildingSize}</span>
                            </span>
                            <span className="generalInfoTextNZPDF">
                                <strong className="generalInfoStrongNZPDF">CLIMATE:</strong>
                                <span className="generalInfoContentNZPDF">{nzClimate}</span>
                            </span>
                        </div>
                        <div>
                            <div
                                style={{
                                    width: "100%",
                                    padding: "0 50px 20px 50px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "5px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: "20px 15px",
                                        background: "#93BB49",
                                    }}
                                >
                                    <span
                                        className="titleFontNZPDF"
                                        style={{
                                            fontSize: "24px",
                                        }}
                                    >
                                        Upgrades Include
                                    </span>
                                </div>
                                <div
                                    style={{
                                        paddingTop: "15px",
                                        display: "grid",
                                        gridTemplateColumns:
                                            nzUpgradesIncluded.length >= maxColumnLength ? "1fr 1fr" : "1fr",
                                        rowGap: "10px",
                                        columnGap: "15px",
                                    }}
                                >
                                    {nzUpgradesIncluded.map((label, index) => (
                                        <div key={index}>
                                            <span className="bodyFontNZPDF">{label}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style type="text/css" media="print">
                {
                    "\
                    @page { size: 8.5in 11in; }\
                    "
                }
            </style>
        </div>
    );
};

export default NZReportPDFPage1;
